/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

var page = require('./page'),
	googletaglinchpin = require('int_googletagmanager/googletaglinchpin'),
	global = require('./global');

var pages = {
	cart: require('./pages/cart'),
	contactus: require('./pages/contactus'),
	help: require('./pages/helpcentre'),
	compare: require('./pages/compare'),
	error: require('./pages/error'),
	giftguide: require('./pages/giftguide'),
	hampers: require('./pages/product/hampers'),
	product: require('./pages/product'),
	quickorder: require('./pages/quickorder'),
	reminders: require('./pages/reminders'),
	search: require('./pages/search'),
	storefront: require('./pages/storefront'),
	storelocator: require('./pages/storelocator'),
	unsubscribe: require('./pages/unsubscribe'),
	wishlist: require('./pages/wishlist'),
	giftedproduct: require('./pages/giftedproduct'),
	vipme: require('./pages/vipme')
};

var storefrontbase = {
	init: function () {
		global.init();

		// execute page specific initializations
		$.extend(page, window.pageContext);
		var ns = page.ns;
		if (ns && pages[ns] && pages[ns].init) {
			pages[ns].init();
		}

		if (SitePreferences.GTM_ENABLED) {
			// init namespace specific events for Linchpin GTM analytics
			if (window.pageContext.ns) {
				googletaglinchpin.init(window.pageContext.ns);
			}
		}
	}
};

// initialize app
$(document).ready(function () {
	storefrontbase.init();
});
